import { useSelector, useDispatch } from 'react-redux';
import { RootReducer } from 'redux/reducers';
import { toggleDsPick } from 'redux/mode/actions';
import { DesignSystemToken } from 'designSystem/types';
import { getColorString } from 'designSystem/content/util';
import * as S from './styles';

interface ColorTableProps {
	tokens: DesignSystemToken[];
}

const ColorTable = ({ tokens }: ColorTableProps) => {
	const dispatch = useDispatch();
	const selectedPicks = useSelector((r: RootReducer) => r.mode.selectedDsPicks);

	//----------------------------------------------------------------------
	// HANDLERS
	//----------------------------------------------------------------------

	const isTokenSelected = (token: DesignSystemToken) =>
		selectedPicks.some((p) => p.kind === 'token' && p.cssVariable === token.cssVariable);

	//----------------------------------------------------------------------
	// RENDERING
	//----------------------------------------------------------------------

	return (
		<S.Base>
			{tokens.map((token) => {
				const color = getColorString(token);
				return (
				<S.Row
					key={token.id}
					type="button"
					$selected={isTokenSelected(token)}
					aria-pressed={isTokenSelected(token)}
					onClick={() =>
						dispatch(toggleDsPick({ kind: 'token', cssVariable: token.cssVariable }))
					}
				>
						<S.Swatch $color={color} />
						<S.Name>{token.name}</S.Name>
						<S.Variable>{token.cssVariable}</S.Variable>
						<S.Hex>{color}</S.Hex>
					</S.Row>
				);
			})}
		</S.Base>
	);
};

export default ColorTable;
